export const DATETIME_FORMATS = {
  "M/d/y HH:mm:ss.uu": "MM/DD/YYYY HH:MI:SS.FF2",
  "d/M/y HH:mm:ss.uu": "DD/MM/YYYY HH:MI:SS.FF2",
  "y/M/d HH:mm:ss.uu": "YYYY/MM/DD HH:MI:SS.FF2",
  "M-d-y HH:mm:ss.uu": "MM-DD-YYYY HH:MI:SS.FF2",
  "d-M-y HH:mm:ss.uu": "DD-MM-YYYY HH:MI:SS.FF2",
  "y-M-d HH:mm:ss.uu": "YYYY-MM-DD HH:MI:SS.FF2",
  "y-M-d HH:mm:ss.u": "YYYY-MM-DD HH:MI:SS.FF3", // Specifically adding this as we store timestamp in this format in all modeling tables
  "M.d.y HH:mm:ss.uu": "MM.DD.YYYY HH:MI:SS.FF2",
  "d.M.y HH:mm:ss.uu": "DD.MM.YYYY HH:MI:SS.FF2",
  "y.M.d HH:mm:ss.uu": "YYYY.MM.DD HH:MI:SS.FF2",
  "d-MMM-y HH:mm:ss.uu": "DD-MON-YYYY HH:MI:SS.FF2",
  "d MMM y HH:mm:ss.uu": "DD MON YYYY HH:MI:SS.FF2",
  "d-MMMM-y HH:mm:ss.uu": "DD-MMMM-YYYY HH:MI:SS.FF2",
  "d MMMM y HH:mm:ss.uu": "DD MMMM YYYY HH:MI:SS.FF2",
  "M/d/y HH:mm:ss": "MM/DD/YYYY HH:MI:SS",
  "d/M/y HH:mm:ss": "DD/MM/YYYY HH:MI:SS",
  "y/M/d HH:mm:ss": "YYYY/MM/DD HH:MI:SS",
  "M-d-y HH:mm:ss": "MM-DD-YYYY HH:MI:SS",
  "d-M-y HH:mm:ss": "DD-MM-YYYY HH:MI:SS",
  "y-M-d HH:mm:ss": "YYYY-MM-DD HH:MI:SS",
  "M.d.y HH:mm:ss": "MM.DD.YYYY HH:MI:SS",
  "d.M.y HH:mm:ss": "DD.MM.YYYY HH:MI:SS",
  "y.M.d HH:mm:ss": "YYYY.MM.DD HH:MI:SS",
  "d-MMM-y HH:mm:ss": "DD-MON-YYYY HH:MI:SS",
  "d MMM y HH:mm:ss": "DD MON YYYY HH:MI:SS",
  "d-MMMM-y HH:mm:ss": "DD-MMMM-YYYY HH:MI:SS",
  "d MMMM y HH:mm:ss": "DD-MMMM-YYYY HH:MI:SS",
  "M/d/y hh:mm:ss.uu a": "MM/DD/YYYY HH12:MI:SS.FF2 AM",
  "d/M/y hh:mm:ss.uu a": "DD/MM/YYYY HH12:MI:SS.FF2 AM",
  "y/M/d hh:mm:ss.uu a": "YYYY/MM/DD HH12:MI:SS.FF2 AM",
  "M-d-y hh:mm:ss.uu a": "MM-DD-YYYY HH12:MI:SS.FF2 AM",
  "d-M-y hh:mm:ss.uu a": "DD-MM-YYYY HH12:MI:SS.FF2 AM",
  "y-M-d hh:mm:ss.uu a": "YYYY-MM-DD HH12:MI:SS.FF2 AM",
  "M.d.y hh:mm:ss.uu a": "MM.DD.YYYY HH12:MI:SS.FF2 AM",
  "d.M.y hh:mm:ss.uu a": "DD.MM.YYYY HH12:MI:SS.FF2 AM",
  "y.M.d hh:mm:ss.uu a": "YYYY.MM.DD HH12:MI:SS.FF2 AM",
  "d-MMM-y hh:mm:ss.uu a": "DD-MON-YYYY HH12:MI:SS.FF2 AM",
  "d MMM y hh:mm:ss.uu a": "DD MON YYYY HH12:MI:SS.FF2 AM",
  "d-MMMM-y hh:mm:ss.uu a": "DD-MMMM-YYYY HH12:MI:SS.FF2 AM",
  "d MMMM y h:mm:ss.uu a": "DD MMMM YYYY HH12:MI:SS.FF2 AM",
  "M/d/y hh:mm:ss a": "MM/DD/YYYY HH12:MI:SS AM",
  "d/M/y hh:mm:ss a": "DD/MM/YYYY HH12:MI:SS AM",
  "y/M/d hh:mm:ss a": "YYYY/MM/DD HH12:MI:SS AM",
  "M-d-y hh:mm:ss a": "MM-DD-YYYY HH12:MI:SS AM",
  "d-M-y hh:mm:ss a": "DD-MM-YYYY HH12:MI:SS AM",
  "y-M-d hh:mm:ss a": "YYYY-MM-DD HH12:MI:SS AM",
  "M.d.y hh:mm:ss a": "MM.DD.YYYY HH12:MI:SS AM",
  "d.M.y hh:mm:ss a": "DD.MM.YYYY HH12:MI:SS AM",
  "y.M.d hh:mm:ss a": "YYYY.MM.DD HH12:MI:SS AM",
  "d-MMM-y hh:mm:ss a": "DD-MON-YYYY HH12:MI:SS AM",
  "d MMM y hh:mm:ss a": "DD MON YYYY HH12:MI:SS AM",
  "d-MMMM-y hh:mm:ss a": "DD-MMMM-YYYY HH12:MI:SS AM",
  "d MMMM y hh:mm:ss a": "DD-MMMM-YYYY HH12:MI:SS AM",
  "M/d/y hh:mm a": "MM/DD/YYYY HH12:MI AM",
  f: "MM/DD/YYYY, HH12:MI AM",
  ff: "MON DD, YYYY, HH12:MI AM",
  F: "DD/MM/YYYY HH12:MI:SS AM",
  FF: "DD/MM/YYYY HH12:MI:SS AM",
};

export const MYSQL_DATETIME_FORMATS = {
  "M/d/y HH:mm:ss.uu": "%m/%d/%Y %H:%i:%s.%f",
  "d/M/y HH:mm:ss.uu": "%d/%m/%Y %H:%i:%s.%f",
  "y/M/d HH:mm:ss.uu": "%Y/%m/%d %H:%i:%s.%f",
  "M-d-y HH:mm:ss.uu": "%m-%d-%Y %H:%i:%s.%f",
  "d-M-y HH:mm:ss.uu": "%d-%m-%Y %H:%i:%s.%f",
  "y-M-d HH:mm:ss.uu": "%Y-%m-%d %H:%i:%s.%f",
  "y-M-d HH:mm:ss.u": "%Y-%m-%d %H:%i:%s.%f",
  "M.d.y HH:mm:ss.uu": "%m.%d.%Y %H:%i:%s.%f",
  "d.M.y HH:mm:ss.uu": "%d.%m.%Y %H:%i:%s.%f",
  "y.M.d HH:mm:ss.uu": "%Y.%m.%d %H:%i:%s.%f",
  "d-MMM-y HH:mm:ss.uu": "%d-%b-%Y %H:%i:%s.%f",
  "d MMM y HH:mm:ss.uu": "%d %b %Y %H:%i:%s.%f",
  "d-MMMM-y HH:mm:ss.uu": "%d-%M-%Y %H:%i:%s.%f",
  "d MMMM y HH:mm:ss.uu": "%d %M %Y %H:%i:%s.%f",
  "M/d/y HH:mm:ss": "%m/%d/%Y %H:%i:%s",
  "d/M/y HH:mm:ss": "%d/%m/%Y %H:%i:%s",
  "y/M/d HH:mm:ss": "%Y/%m/%d %H:%i:%s",
  "M-d-y HH:mm:ss": "%m-%d-%Y %H:%i:%s",
  "d-M-y HH:mm:ss": "%d-%m-%Y %H:%i:%s",
  "y-M-d HH:mm:ss": "%Y-%m-%d %H:%i:%s",
  "M.d.y HH:mm:ss": "%m.%d.%Y %H:%i:%s",
  "d.M.y HH:mm:ss": "%d.%m.%Y %H:%i:%s",
  "y.M.d HH:mm:ss": "%Y.%m.%d %H:%i:%s",
  "d-MMM-y HH:mm:ss": "%d-%b-%Y %H:%i:%s",
  "d MMM y HH:mm:ss": "%d %b %Y %H:%i:%s",
  "d-MMMM-y HH:mm:ss": "%d-%M-%Y %H:%i:%s",
  "d MMMM y HH:mm:ss": "%d %M %Y %H:%i:%s",
  "M/d/y hh:mm:ss.uu a": "%m/%d/%Y %h:%i:%s.%f %p",
  "d/M/y hh:mm:ss.uu a": "%d/%m/%Y %h:%i:%s.%f %p",
  "y/M/d hh:mm:ss.uu a": "%Y/%m/%d %h:%i:%s.%f %p",
  "M-d-y hh:mm:ss.uu a": "%m-%d-%Y %h:%i:%s.%f %p",
  "d-M-y hh:mm:ss.uu a": "%d-%m-%Y %h:%i:%s.%f %p",
  "y-M-d hh:mm:ss.uu a": "%Y-%m-%d %h:%i:%s.%f %p",
  "M.d.y hh:mm:ss.uu a": "%m.%d.%Y %h:%i:%s.%f %p",
  "d.M.y hh:mm:ss.uu a": "%d.%m.%Y %h:%i:%s.%f %p",
  "y.M.d hh:mm:ss.uu a": "%Y.%m.%d %h:%i:%s.%f %p",
  "d-MMM-y hh:mm:ss.uu a": "%d-%b-%Y %h:%i:%s.%f %p",
  "d MMM y hh:mm:ss.uu a": "%d %b %Y %h:%i:%s.%f %p",
  "d-MMMM-y hh:mm:ss.uu a": "%d-%M-%Y %h:%i:%s.%f %p",
  "d MMMM y h:mm:ss.uu a": "%d %M %Y %h:%i:%s.%f %p",
  "M/d/y hh:mm:ss a": "%m/%d/%Y %h:%i:%s %p",
  "d/M/y hh:mm:ss a": "%d/%m/%Y %h:%i:%s %p",
  "y/M/d hh:mm:ss a": "%Y/%m/%d %h:%i:%s %p",
  "M-d-y hh:mm:ss a": "%m-%d-%Y %h:%i:%s %p",
  "d-M-y hh:mm:ss a": "%d-%m-%Y %h:%i:%s %p",
  "y-M-d hh:mm:ss a": "%Y-%m-%d %h:%i:%s %p",
  "M.d.y hh:mm:ss a": "%m.%d.%Y %h:%i:%s %p",
  "d.M.y hh:mm:ss a": "%d.%m.%Y %h:%i:%s %p",
  "y.M.d hh:mm:ss a": "%Y.%m.%d %h:%i:%s %p",
  "d-MMM-y hh:mm:ss a": "%d-%b-%Y %h:%i:%s %p",
  "d MMM y hh:mm:ss a": "%d %b %Y %h:%i:%s %p",
  "d-MMMM-y hh:mm:ss a": "%d-%M-%Y %h:%i:%s %p",
  "d MMMM y hh:mm:ss a": "%d %M %Y %h:%i:%s %p",
  "M/d/y hh:mm a": "%m/%d/%Y %h:%i %p",
  f: "%f",
  ff: "%f%f",
  F: "%f",
  FF: "%f%f",
};
